//--Provider系をアプリケーション全体に設定--//
import React from 'react';
import { Provider } from 'react-redux'
import createStore from '../redux/var1/store'
//import createStore from '../redux/testRedux/test__store'

const store = createStore()
export default ({element}: {element: JSX.Element | JSX.Element[]}) => <Provider store={store}>{element}</Provider>